import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { VehicleColorTypeEnum } from '../enums/vehicle-color-type.enum';

/**
 * Vehicle color search DTO for lists
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleColorSearchDto extends BaseSearchDto {
	name!: string;
	type!: VehicleColorTypeEnum;
	externalReference?: string;
	files?: FileDto[];

	displayValue(): string | null {
		return `${this.name}`;
	}

	shortDisplayValue(): string | null {
		return null;
	}

	periodDisplayValue(): string | null {
		return null;
	}

	extraDisplayValue(): string | null {
		return null;
	}

	pillDisplayValue(): string | null {
		return `${this.type}`;
	}
}
